<template>
  <div class="largeImgWrap">
    <img class="img" :src="img" alt="">
    <div v-if="labelText">
      <span class="lightText">标签</span>
      <span>{{labelText}}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['img', 'labelText']
}
</script>

<style lang="scss" scoped>
.largeImgWrap{
  // width: 100%;

  .img{
    width: 100%;
    margin-bottom: 10px;
  }
  .lightText{
    font-size: 12px;
    color: #a2a2a2;
    display: inline-block;
    padding-right: 20px;
    line-height: 14px;
  }
}
</style>